import QiyamulLailPrayerCard from './CardQiyamulLail';

export default QiyamulLailPrayerCard;
